import { authGet } from './authMiddleware';

export const getPropertyFilters = async () => {
    return authGet('/api/Property/start');
}